export const TOP_SEO_ITEMS = 5 satisfies number;
